<template>
    <div>
        <!-- FASE 4 / BLOCO AE — CI 3, 13, 16, 31, 32, 33, 34, 37, 49, 50, 52, 53 -->

        <el-form @submit.native.prevent="salvar" :model="dados" ref="dados" label-position="top">

            <el-row :gutter="10">
                <el-col :xs="24" :sm="6" :md="6">
                    <el-form-item label="Tipo" prop="tarefa_tipo_id" :rules="[$requiredChange]" key="tipo">
                        <el-select v-model="dados.tarefa_tipo_id" placeholder="Selecione" style="width:100%"
                                   @change="aoTrocarTipo">
                            <el-option v-for="t in tipos" :key="t.id" :label="t.nome" :value="t.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="18" :md="18">
                    <el-form-item label="Assunto" prop="assunto" :rules="[$requiredBlur]" key="assunto">
                        <el-input v-model="dados.assunto" maxlength="255"
                                  placeholder="Ex.: Convocação para reunião pedagógica"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- CI 33 — um ou mais grupos, ou participantes específicos -->
            <el-row :gutter="10">
                <el-col :xs="24" :sm="12" :md="12">
                    <el-form-item label="Grupos de trabalho">
                        <el-select v-model="gruposSelecionados" multiple filterable placeholder="Nenhum"
                                   style="width:100%">
                            <el-option v-for="g in grupos" :key="g.id" :label="g.caminho" :value="g.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12">
                    <el-form-item label="Participantes específicos">
                        <el-select v-model="usuariosSelecionados" multiple filterable remote
                                   :remote-method="buscarUsuarios" :loading="buscando"
                                   placeholder="Digite o nome" style="width:100%">
                            <el-option v-for="u in usuarios" :key="u.id" :label="u.name" :value="u.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <!--
              CI 1 (bloco AF-1) — "comunicação interna E EXTERNA".

              A auditoria 13 mostrou que a palavra "externa" tinha sido ignorada: só se
              enviava para gente cadastrada. Aqui entra quem está fora do sistema e recebe a
              comunicação por e-mail.

              Externo RECEBE, não ENTRA: CI 2 exige que o acesso seja só de cadastrados. Por
              isso não vira participante, não confirma leitura e não responde pela ferramenta —
              e o e-mail avisa isso a ele.
            -->
            <el-row :gutter="10" v-if="podeExterno">
                <el-col :xs="24">
                    <el-form-item label="Destinatários externos (recebem por e-mail)">
                        <el-row :gutter="6">
                            <el-col :xs="24" :sm="9">
                                <el-input v-model="externoNovo.email" placeholder="email@dominio.gov.br"
                                          size="small" @keyup.enter.native="incluirExterno"></el-input>
                            </el-col>
                            <el-col :xs="16" :sm="9">
                                <el-input v-model="externoNovo.nome" placeholder="Nome (opcional)"
                                          size="small" @keyup.enter.native="incluirExterno"></el-input>
                            </el-col>
                            <el-col :xs="8" :sm="6">
                                <el-button type="primary" size="small" icon="el-icon-plus"
                                           :disabled="!externoNovo.email" @click="incluirExterno">
                                    INCLUIR
                                </el-button>
                            </el-col>
                        </el-row>

                        <div class="u-mt-10" v-if="externos.length">
                            <el-tag v-for="e in externos" :key="e.id" class="u-mr-5"
                                    :type="e.situacao === 'enviado' ? 'success' : (e.situacao === 'falha' ? 'danger' : 'info')"
                                    :closable="e.situacao !== 'enviado'"
                                    @close="removerExterno(e)">
                                {{ e.nome || 'externo' }}
                                <small v-if="e.situacao !== 'pendente'">· {{ e.situacao }}</small>
                            </el-tag>
                        </div>

                        <small class="u-text-muted" v-if="!paramId">
                            Salve o rascunho para incluir destinatários externos.
                        </small>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- CI 31 — texto formatado. O HTML é sanitizado no backend. -->
            <el-row :gutter="10">
                <el-col :xs="24">
                    <el-form-item label="Conteúdo">
                        <ckeditor v-model="dados.conteudo" :key="'ck-'+(dados.id||'novo')"></ckeditor>
                        <div class="dica">
                            Para mencionar alguém e notificá-lo, escreva
                            <code>@[Nome da pessoa](id)</code> — a menção só alcança quem participa da tarefa.
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :xs="24" :sm="6" :md="6">
                    <!-- CI 49 -->
                    <el-form-item :label="prazoObrigatorio ? 'Prazo de conclusão (obrigatório)' : 'Prazo de conclusão'">
                        <el-date-picker v-model="dados.prazo_conclusao" type="datetime" style="width:100%"
                                        value-format="yyyy-MM-dd HH:mm:ss" placeholder="Sem prazo"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6" :md="6">
                    <!-- CI 52 -->
                    <el-form-item label="Agendar envio para">
                        <el-date-picker v-model="dados.agendado_para" type="datetime" style="width:100%"
                                        value-format="yyyy-MM-dd HH:mm:ss" placeholder="Enviar agora"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12">
                    <el-form-item label="Opções">
                        <!-- CI 50 -->
                        <el-checkbox v-model="dados.concluir_automaticamente">
                            Concluir automaticamente ao atingir o prazo
                        </el-checkbox>
                        <br>
                        <!-- CI 34 -->
                        <el-checkbox v-model="dados.privada">
                            Privada — só entre remetente e destinatários originais
                        </el-checkbox>
                        <br>
                        <!-- CI 14 -->
                        <el-checkbox v-model="dados.somente_solicitante_ve_atualizacoes">
                            Só eu vejo as respostas dos participantes
                        </el-checkbox>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- CI 32 — modo redator: redige um, envia outro -->
            <el-row :gutter="10">
                <el-col :xs="24" :sm="12" :md="12">
                    <el-form-item label="Enviar em nome de (modo redator)">
                        <el-select v-model="dados.remetente_user_id" filterable remote clearable
                                   :remote-method="buscarUsuarios" :loading="buscando"
                                   placeholder="Eu mesmo" style="width:100%">
                            <el-option v-for="u in usuarios" :key="u.id" :label="u.name" :value="u.id"></el-option>
                        </el-select>
                        <div class="dica">Deixe em branco para enviar em seu próprio nome.</div>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- CI 3, 53 — anexos -->
            <el-row :gutter="10">
                <el-col :xs="24">
                    <el-form-item label="Anexos">
                        <el-upload class="area-arrastar" drag multiple action=""
                                   :auto-upload="false" :file-list="listaArquivos"
                                   :on-change="aoMudarLista" :on-remove="aoMudarLista">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">Arraste arquivos aqui ou <em>clique para selecionar</em></div>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :xs="24">
                    <el-form-item class="u-text-right u-mt-15">
                        <el-button type="default" @click="$router.push('/admin/tarefa')">CANCELAR</el-button>
                        <el-button class="u-ml-10" type="info" @click="salvar(false)">SALVAR RASCUNHO</el-button>
                        <el-button class="u-ml-10" type="primary" native-type="submit" id="btn-tarefa">
                            {{ dados.agendado_para ? 'AGENDAR ENVIO' : 'ENVIAR' }}
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>

import ckeditor from '@/shared/ckeditor/ckeditor'

export default {
    props: ['paramId'],
    data: () => ({
        dados: {
            id: '', tarefa_tipo_id: '', assunto: '', conteudo: '',
            prazo_conclusao: '', agendado_para: '', concluir_automaticamente: false,
            privada: false, somente_solicitante_ve_atualizacoes: false, remetente_user_id: ''
        },
        tipos: [],
        grupos: [],
        usuarios: [],
        gruposSelecionados: [],
        usuariosSelecionados: [],
        listaArquivos: [],
        buscando: false,
        prazoObrigatorio: false,

        // CI 1 — comunicação externa
        externos: [],
        externoNovo: { email: '', nome: '' }
    }),
    mounted () {
        this.carregarTipos()
        this.carregarGrupos()

        // CI 37 — rascunho "em edição, para ser enviado posteriormente": precisa reabrir.
        if (this.paramId) { this.carregarRascunho(); this.carregarExternos() }
    },
    computed: {
        /* Só faz sentido depois que o rascunho existe: o vínculo é com a tarefa. */
        podeExterno () { return !!this.paramId }
    },
    methods: {
        base () { return this.$store.state.config.baseUrlApi },

        // ------------------------------------------------ CI 1: comunicação externa
        carregarExternos () {
            if (!this.paramId) return
            this.$axios.get(`${this.base()}/api/tarefa/externo/listar/${this.paramId}`, this.auth())
                .then(r => { this.externos = r.data || [] })
                .catch(() => { this.externos = [] })
        },
        incluirExterno () {
            if (!this.paramId) {
                this.$message.warning('Salve o rascunho antes de incluir destinatários externos.')
                return
            }

            this.$axios.post(`${this.base()}/api/tarefa/externo/incluir/${this.paramId}`, {
                email: this.externoNovo.email, nome: this.externoNovo.nome
            }, this.auth()).then(() => {
                this.externoNovo = { email: '', nome: '' }
                this.carregarExternos()
            }).catch(e => {
                this.$message.error((e.response && e.response.data && e.response.data.message)
                    || 'Não foi possível incluir este e-mail.')
            })
        },
        removerExterno (e) {
            this.$axios.delete(`${this.base()}/api/tarefa/externo/remover/${e.id}`, this.auth())
                .then(() => this.carregarExternos())
                .catch(err => {
                    this.$message.error((err.response && err.response.data && err.response.data.message)
                        || 'Não foi possível remover.')
                })
        },
        auth () { return this.$store.getters.getHeaderAuth },

        instituicaoAtual () {
            const i = this.$store.state.config.instituicao
            return i ? i.id : null
        },

        erro (e) {
            window.eventBus.$emit('loading', false)
            const d = e && e.response ? e.response.data : null
            let msg = 'Não foi possível concluir a operação.'
            if (d && typeof d.erro === 'string') msg = d.erro
            else if (d && d.erro && d.erro.text) msg = d.erro.text
            window.eventBus.$emit('alert', { msg: msg, type: 'error' })
            this.$store.commit('throwException', e)
        },

        /**
         * Reabre um rascunho para continuar a redação.
         *
         * Só rascunho e agendada são editáveis — o backend recusa o resto, e a tela leva o
         * usuário ao detalhe em vez de deixá-lo num formulário que não vai salvar.
         */
        carregarRascunho () {
            window.eventBus.$emit('loading', true)

            this.$axios.get(`${this.base()}/api/tarefa/detalhe/${this.paramId}`, this.auth()).then(r => {
                window.eventBus.$emit('loading', false)

                const t = r.data.tarefa

                if (t.situacao !== 'rascunho' && t.situacao !== 'agendada') {
                    window.eventBus.$emit('alert', {
                        msg: 'Esta tarefa já foi enviada e não pode mais ser editada.', type: 'warning'
                    })
                    this.$router.push('/admin/tarefa/detalhe/' + t.id)
                    return
                }

                this.dados = {
                    id: t.id,
                    tarefa_tipo_id: t.tarefa_tipo_id,
                    assunto: t.assunto,
                    conteudo: t.conteudo || '',
                    prazo_conclusao: t.prazo_conclusao || '',
                    agendado_para: t.agendado_para || '',
                    concluir_automaticamente: !!t.concluir_automaticamente,
                    privada: !!t.privada,
                    somente_solicitante_ve_atualizacoes: !!t.somente_solicitante_ve_atualizacoes,
                    remetente_user_id: ''
                }

                this.aoTrocarTipo(t.tarefa_tipo_id)

                const ps = r.data.participantes || []
                this.gruposSelecionados   = ps.filter(p => p.tipo === 'grupo').map(p => p.ref_id)
                this.usuariosSelecionados = ps.filter(p => p.tipo === 'usuario').map(p => p.ref_id)

                // O seletor precisa conhecer os nomes de quem já é participante.
                this.usuarios = ps.filter(p => p.tipo === 'usuario')
                    .map(p => ({ id: p.ref_id, name: p.nome }))
            }).catch(e => { this.erro(e) })
        },

        carregarTipos () {
            this.$axios.post(`${this.base()}/api/tarefa-tipo/getAll`, {}, this.auth())
                .then(r => { this.tipos = r.data })
                .catch(e => { this.erro(e) })
        },

        carregarGrupos () {
            this.$axios.post(`${this.base()}/api/grupo-trabalho/arvore`, {}, this.auth())
                .then(r => { this.grupos = this.achatar(r.data) })
                .catch(e => { this.erro(e) })
        },

        achatar (nos, acc) {
            acc = acc || []
            nos.forEach(n => { acc.push(n); if (n.filhos && n.filhos.length) this.achatar(n.filhos, acc) })
            return acc
        },

        aoTrocarTipo (id) {
            const t = this.tipos.find(x => x.id === id)
            this.prazoObrigatorio = !!(t && t.prazo_obrigatorio)

            if (t && t.prazo_padrao_dias && !this.dados.prazo_conclusao) {
                const d = new Date()
                d.setDate(d.getDate() + t.prazo_padrao_dias)
                this.dados.prazo_conclusao = d.toISOString().slice(0, 19).replace('T', ' ')
            }
        },

        /**
         * Busca usuários pelo primeiro grupo selecionado.
         *
         * O backend só devolve quem pertence à instituição do grupo — é ele que decide,
         * não a tela.
         */
        buscarUsuarios (termo) {
            if (!termo || termo.length < 2) return

            const grupoId = this.gruposSelecionados.length
                ? this.gruposSelecionados[0]
                : (this.grupos.length ? this.grupos[0].id : null)

            if (!grupoId) {
                window.eventBus.$emit('alert', {
                    msg: 'Crie ou selecione um grupo de trabalho para localizar pessoas.', type: 'warning'
                })
                return
            }

            this.buscando = true
            this.$axios.post(`${this.base()}/api/grupo-trabalho/usuarios-disponiveis/${grupoId}`,
                { termo: termo }, this.auth()).then(r => {
                this.usuarios = r.data
                this.buscando = false
            }).catch(e => { this.buscando = false; this.erro(e) })
        },

        aoMudarLista (file, fileList) { this.listaArquivos = fileList },

        participantes () {
            const p = []
            this.gruposSelecionados.forEach(id => p.push({ tipo: 'grupo', ref_id: id }))
            this.usuariosSelecionados.forEach(id => p.push({ tipo: 'usuario', ref_id: id }))
            return p
        },

        salvar (enviar) {
            const deveEnviar = enviar !== false

            this.$refs.dados.validate(valido => {
                if (!valido) return

                const payload = {
                    tarefa_tipo_id: this.dados.tarefa_tipo_id,
                    instituicao_id: this.instituicaoAtual(),
                    assunto: this.dados.assunto,
                    conteudo: this.dados.conteudo,
                    prazo_conclusao: this.dados.prazo_conclusao || null,
                    concluir_automaticamente: this.dados.concluir_automaticamente,
                    privada: this.dados.privada,
                    somente_solicitante_ve_atualizacoes: this.dados.somente_solicitante_ve_atualizacoes,
                    participantes: this.participantes()
                }

                if (this.dados.remetente_user_id) payload.remetente_user_id = this.dados.remetente_user_id

                window.eventBus.$emit('loading', true)

                // CI 37 — rascunho reaberto é ATUALIZADO, não duplicado.
                const url = this.dados.id
                    ? `${this.base()}/api/tarefa/update/${this.dados.id}`
                    : `${this.base()}/api/tarefa/store`

                this.$axios.post(url, payload, this.auth()).then(r => {
                    const id = r.data.id
                    return this.enviarAnexos(id).then(() => id)
                }).then(id => {
                    if (!deveEnviar) {
                        window.eventBus.$emit('loading', false)
                        window.eventBus.$emit('alert', { msg: 'Sucesso! - Rascunho salvo.', type: 'success' })
                        this.$router.push('/admin/tarefa/rascunhos')
                        return
                    }

                    const url = this.dados.agendado_para
                        ? `${this.base()}/api/tarefa/agendar/${id}`
                        : `${this.base()}/api/tarefa/enviar/${id}`

                    const corpo = this.dados.agendado_para ? { agendado_para: this.dados.agendado_para } : {}

                    return this.$axios.post(url, corpo, this.auth()).then(() => {
                        window.eventBus.$emit('loading', false)
                        window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                        this.$router.push('/admin/tarefa/detalhe/' + id)
                    }).catch(e => {
                        // A tarefa existe como rascunho; leva o usuário até ela em vez de
                        // deixá-lo no formulário achando que perdeu tudo.
                        this.erro(e)
                        this.$router.push('/admin/tarefa/detalhe/' + id)
                    })
                }).catch(e => { this.erro(e) })
            })
        },

        enviarAnexos (id) {
            if (!this.listaArquivos.length) return Promise.resolve()

            const form = new FormData()
            this.listaArquivos.forEach(f => { if (f.raw) form.append('arquivos[]', f.raw) })

            const cfg = Object.assign({}, this.auth())
            cfg.headers = Object.assign({}, cfg.headers, { 'Content-Type': 'multipart/form-data' })

            return this.$axios.post(`${this.base()}/api/tarefa/anexar/${id}`, form, cfg)
        }
    },
    components: { ckeditor }
}
</script>
<style scoped>
.dica { font-size: 12px; color: #909399; margin-top: 4px; }
.dica code { background: #f5f7fa; padding: 1px 4px; border-radius: 3px; }
.area-arrastar >>> .el-upload, .area-arrastar >>> .el-upload-dragger { width: 100%; }
.area-arrastar >>> .el-upload-dragger { height: 100px; }
</style>
